import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import useSidebar from "../../hooks/useSidebar";

import NavbarUser from "./NavbarUser";
import Messages from "./Messages";

const NavbarComponent = () => {
  const { isOpen, setIsOpen } = useSidebar();

  return (
    <Navbar variant="light" expand className="navbar-bg">
      <span
        className="sidebar-toggle d-flex"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <i className="hamburger align-self-center" />
      </span>

      <Navbar.Collapse>
          <Nav className="navbar-align">

          <Messages />
          <NavbarUser />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;
